import React from 'react';
import { User } from 'lucide-react';
export function AudienceSection() {
  const practitioners = ['Dieticians & Nutritionists', 'Life & Wellness Coaches', 'Gut Health Coaches', 'Fitness Trainers', 'Therapists', 'Holistic Practitioners'];
  return <section className="py-20 px-6 bg-[#7B9AAA]/10" data-id="element-1">
      <div className="max-w-4xl mx-auto text-center" data-id="element-2">
        <h2 className="text-3xl font-bold text-[#2D2D2D] mb-12" data-id="element-3">
          Built for professionals who work 1-on-1
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 mb-12" data-id="element-4">
          {practitioners.map((type, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-sm flex flex-col items-center justify-center text-center hover:shadow-md transition-shadow duration-300" data-id="element-5">
              <div className="w-10 h-10 bg-[#7B9AAA]/20 rounded-full flex items-center justify-center mb-3 text-[#7B9AAA]" data-id="element-6">
                <User className="w-5 h-5" data-id="element-7" />
              </div>
              <span className="font-medium text-[#2D2D2D]" data-id="element-8">{type}</span>
            </div>)}
        </div>

        <p className="text-sm text-[#2D2D2D]/60 bg-white/50 inline-block px-4 py-2 rounded-full" data-id="element-9">
          Note: Not built for large hospitals or call-center clinics
        </p>
      </div>
    </section>;
}